import React, { useState, useMemo, useCallback } from "react";
import { Modal, DatePicker } from "antd";
import Wrapper from "./style";
import { CSVLink } from "react-csv";
import { CloseOutlined } from "@ant-design/icons";

const ExportData = ({ showModal, hideModal, dataList }) => {
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });

  const formatDate = useCallback((date) => {
    if (!date) return null;
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();
    return [year, month, day].join('-');
  }, []);

  const filteredData = useMemo(() => {
    if (!dateRange.startDate || !dateRange.endDate) return dataList;

    const start = new Date(dateRange.startDate);
    const end = new Date(dateRange.endDate);

    return dataList.filter(({ createdAt, dateJoined }) => {
      const date = new Date(createdAt || dateJoined);
      return date >= start && date <= end;
    });
  }, [dataList, dateRange]);

  return (
    <Modal
      visible={showModal}
      closable={false}
      footer={null}
      centered
      onCancel={() => hideModal(false)}
      bodyStyle={{
        padding: "23px 73px 44px 73px",
        borderRadius: "12px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", marginBottom: "27px" }}>
        <CloseOutlined style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => hideModal(false)} />
      </div>
      <Wrapper>
        <div className="title" style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px" }}>Export Data</div>
        <div className="cw-content">
          <div className="mb-3">
            <div className="label mb-1">Start Date</div>
            <DatePicker
              style={{ width: '100%' }}
              onChange={(e) => setDateRange(prev => ({ ...prev, startDate: formatDate(e) }))}
            />
          </div>

          <div className="mb-3">
            <div className="label mb-1">End Date</div>
            <DatePicker
              style={{ width: '100%' }}
              onChange={(e) => setDateRange(prev => ({ ...prev, endDate: formatDate(e) }))}
            />
          </div>
        </div>
      </Wrapper>

      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: 40 }}>
        <CSVLink
          data={filteredData}
          style={{
            background: "#FF4B01",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "14px",
            padding: "10px 30px",
            textDecoration: "none"
          }}
          filename={"Referral-History.csv"}
        >
          Export CSV
        </CSVLink>
      </div>
    </Modal>
  );
};

export default ExportData;
